var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowAltCircleLeft';
import { faArrowAltCircleRight } from '@fortawesome/pro-regular-svg-icons/faArrowAltCircleRight';
var SCarouselWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"])));
var SCarouselSlide = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  opacity: ", ";\n  transition: all 0.5s ease;\n  width: 100%;\n"], ["\n  flex: 0 0 auto;\n  opacity: ", ";\n  transition: all 0.5s ease;\n  width: 100%;\n"])), function (props) {
  return props.active ? 1 : 0;
});
var SCarouselSlides = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  ", ";\n  transition: all 0.5s ease;\n  margin: 2em;\n  position: relative;\n"], ["\n  display: flex;\n  ", ";\n  transition: all 0.5s ease;\n  margin: 2em;\n  position: relative;\n"])), function (props) {
  return props.currentSlide && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      transform: translateX(-", "%);\n    "], ["\n      transform: translateX(-", "%);\n    "])), props.currentSlide * 100);
});
var LeftButton = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  left: 0px;\n  padding: -10px;\n"], ["\n  position: absolute;\n  left: 0px;\n  padding: -10px;\n"])));
var RightButton = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  right: 0px;\n  padding: 10px;\n"], ["\n  position: absolute;\n  right: 0px;\n  padding: 10px;\n"])));
var FontAwesomeIconHoverable = styled(FontAwesomeIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  opacity: 0.5;\n  &:hover {\n    color: grey;\n  }\n  &:active {\n    color: black;\n  }\n"], ["\n  opacity: 0.5;\n  &:hover {\n    color: grey;\n  }\n  &:active {\n    color: black;\n  }\n"])));

var CarouselForm = function CarouselForm(_a) {
  var interval = _a.interval,
      loopable = _a.loopable,
      children = _a.children;

  var _b = React.useState(0),
      currentSlide = _b[0],
      setCurrentSlide = _b[1];

  var activeSlide = children.map(function (slide, index) {
    return React.createElement(SCarouselSlide, {
      active: currentSlide === index,
      key: index
    }, slide);
  });

  if (interval !== undefined && interval > 0) {
    setTimeout(function () {
      setCurrentSlide((currentSlide + 1) % activeSlide.length);
    }, interval);
  }

  return React.createElement("div", null, React.createElement(SCarouselWrapper, null, React.createElement(SCarouselSlides, {
    currentSlide: currentSlide
  }, activeSlide), (currentSlide > 0 || loopable) && React.createElement(LeftButton, {
    onClick: function onClick() {
      setCurrentSlide((currentSlide - 1 + activeSlide.length) % activeSlide.length);
    }
  }, React.createElement(FontAwesomeIconHoverable, {
    icon: faArrowAltCircleLeft,
    size: "4x"
  })), (currentSlide + 1 < activeSlide.length || loopable) && React.createElement(RightButton, {
    onClick: function onClick() {
      setCurrentSlide((currentSlide + 1) % activeSlide.length);
    }
  }, React.createElement(FontAwesomeIconHoverable, {
    icon: faArrowAltCircleRight,
    size: "4x"
  }))));
};

export default CarouselForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;